import { AppError } from './app-error';

export class ForbiddenError extends AppError { }